export default "__VITE_ASSET__B9sajt3W__"